<h2 matDialogTitle class="m-b-0">Mover a empresa</h2>

<div mat-dialog-content id="company-mover-card" class=" m-t-10">
    <form class="form" role="form" [formGroup]="form">
        <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p ">
            <div class="m-t-5">
                <div fxFlex="100" fxFlex.gt-sm="70" class="m-r-10">
                    <div class="w-full">
                        <mat-label>Empresa</mat-label>
                        <app-tree-view (companyNode)="onCompanySelcted($event)" [origin]="1"></app-tree-view>
                    </div>
                </div>

                <div fxFlex="100" fxFlex.gt-sm="30" class="m-r-10 p-t-15">
                    <mat-checkbox class="example-margin" formControlName="moveLeaves">
                        Mover todas la bajas
                    </mat-checkbox>
                </div>
            </div>
        </div>
    </form>
</div>

<mat-progress-bar class="m-t-10" mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
<div class="text-a-r p-b-15 p-r-10">
    <button class="m-r-15" mat-raised-button color="accent" (click)="onAccept()">Guardar</button>
    <button mat-raised-button color="warn" (click)="onCancel()">Cancelar</button>
</div>